// Crop a region (0-1 fractions) out of an image URL -> PNG File
export async function cropImage(url, box, name = 'Deck') {
  const img = await new Promise((res, rej) => {
    const i = new Image()
    i.crossOrigin = 'anonymous'
    i.onload = () => res(i)
    i.onerror = () => rej(new Error('Could not load the plan image'))
    i.src = url
  })
  const sx = Math.round(box.x * img.naturalWidth)
  const sy = Math.round(box.y * img.naturalHeight)
  const sw = Math.round(box.w * img.naturalWidth)
  const sh = Math.round(box.h * img.naturalHeight)
  if (sw < 8 || sh < 8) throw new Error('Crop too small')
  const canvas = document.createElement('canvas')
  canvas.width = sw; canvas.height = sh
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, sw, sh)
  ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh)
  const blob = await new Promise(r => canvas.toBlob(r, 'image/png'))
  return new File([blob], name.replace(/[^\w\s-]/g, '').trim() + '.png', { type: 'image/png' })
}
